module.exports = __webpack_public_path__ + "2638f408e4f549ff9a70c8ef85bc4d3f.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/icons/icons.woff
// module id = 384
// module chunks = 0